export const formatSearchPlaceholder = (searchBy, i18n) => {
  const prefix = searchBy ? i18n.t('SearchBy') : i18n.t('Search');

  if (Array.isArray(searchBy)) {
    const searchByFields = searchBy?.map((key) => key)?.join(', ');
    return `${prefix} ${searchByFields}`;
  }

  if (searchBy) {
    return `${prefix} ${searchBy}`;
  }

  return prefix;
};
